import styled from 'styled-components';

const BlogIndividualTemplateStyle = styled.section`
	--marginT: var(--sp8x);
	--textDistance: var(--sp13x);
	--gap: var(--sp4x);
	--shareMarginT: var(--sp5x);

	.wrapper-related-titles {
		margin-top: var(--sectionDistance);
	}

	.related-text {
		/* margin-top: var(--textDistance); */
	}

	.wrapper-blogs {
		margin-top: var(--marginT);
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: var(--gap);
	}

	.share-bottom {
		display: none;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--textDistance: var(--sp10x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marginT: var(--sp7x);
		--textDistance: var(--sp8x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marginT: var(--sp6x);
		--textDistance: var(--sp7x);
		--gap: var(--sp3x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--marginT: var(--sp5x);
		--textDistance: var(--sp6x);
		--gap: var(--sp2-5x);
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marginT: var(--sp4x);
		--textDistance: var(--sp4x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--textDistance: var(--sp4x);
		--gap: var(--sp2x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--gap: var(--sp4x);
		--shareMarginT: var(--sp4x);

		.wrapper-blogs {
			grid-template-columns: 1fr;
		}

		.share-bottom {
			display: block;
			margin-top: var(--shareMarginT);

			div {
				flex-direction: row;
			}
		}
	}
`;

export default BlogIndividualTemplateStyle;
